'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _WMPaper = require('@workmarket/front-end-components/dist/WMPaper');

var _WMPaper2 = _interopRequireDefault(_WMPaper);

var _WMHeading = require('@workmarket/front-end-components/dist/WMHeading');

var _WMHeading2 = _interopRequireDefault(_WMHeading);

var _WMText = require('@workmarket/front-end-components/dist/WMText');

var _WMText2 = _interopRequireDefault(_WMText);

var _WMFontIcon = require('@workmarket/front-end-components/dist/WMFontIcon');

var _WMFontIcon2 = _interopRequireDefault(_WMFontIcon);

var _WMRaisedButton = require('@workmarket/front-end-components/dist/WMRaisedButton');

var _WMRaisedButton2 = _interopRequireDefault(_WMRaisedButton);

var _styles = require('@workmarket/front-end-components/dist/common/styles');

var _styles2 = _interopRequireDefault(_styles);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _styles3 = require('./styles');

var _styles4 = _interopRequireDefault(_styles3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLocationString = function getLocationString(city, state, zip) {
	if (city && city.length && state && state.length && zip && zip.length) {
		return city + ', ' + state + ' ' + zip;
	}
	return undefined;
};

var getFoundedString = function getFoundedString(foundedYear) {
	return foundedYear ? 'Founded ' + foundedYear : undefined;
};

var getMemberSinceString = function getMemberSinceString(memberSinceYear) {
	return memberSinceYear && memberSinceYear.length ? 'Work Market member since ' + memberSinceYear.substr(-4) : undefined;
};

var getTeamMembersString = function getTeamMembersString(employeeCount) {
	return employeeCount ? employeeCount + ' Team Members' : undefined;
};

var getOverviewListItems = _ramda2.default.memoize(function (_ref) {
	var website = _ref.website,
	    _ref$location = _ref.location,
	    city = _ref$location.city,
	    state = _ref$location.state,
	    zip = _ref$location.zip,
	    yearFounded = _ref.yearFounded,
	    createdOn = _ref.createdOn,
	    employees = _ref.employees;
	return [{
		icon: 'important_devices',
		id: 'website',
		label: website
	}, {
		icon: 'place',
		id: 'location',
		label: getLocationString(city, state, zip)
	}, {
		icon: 'flag',
		id: 'founded',
		label: getFoundedString(yearFounded)
	}, {
		icon: 'loyalty',
		id: 'memberSince',
		label: getMemberSinceString(createdOn)
	}, {
		icon: 'people',
		id: 'employees',
		label: getTeamMembersString(employees)
	}];
});

var getCompanyTitle = _ramda2.default.memoize(function (name, followedByUser, followedByUserRequested, toggleFunc, blockFunc, blockedByUser, blockByUserRequested, isPublic) {
	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			_WMHeading2.default,
			{
				level: '3'
			},
			name,
			_react2.default.createElement(
				'div',
				{ style: _styles4.default.actionContainer },
				!isPublic && !blockedByUser && _react2.default.createElement(_WMRaisedButton2.default, {
					label: followedByUser ? 'Following' : 'Follow',
					backgroundColor: followedByUser ? _styles4.default.followButtonColors.following : _styles4.default.followButtonColors.follow,
					disabled: followedByUserRequested,
					labelColor: _styles4.default.followButtonLabel.color,
					style: _styles4.default.followButton,
					labelStyle: _styles4.default.followButtonLabel,
					onClick: toggleFunc,
					icon: followedByUser && _react2.default.createElement(
						_WMFontIcon2.default,
						{
							className: 'material-icons',
							id: 'wm-company-page__company-title'
						},
						'done'
					)
				}),
				_react2.default.createElement(_WMRaisedButton2.default, {
					label: blockedByUser ? 'Blocked' : 'Block Company',
					disabled: blockByUserRequested || blockedByUser,
					style: _styles4.default.blockButton,
					onClick: blockFunc
				})
			)
		),
		blockedByUser && _react2.default.createElement(
			'div',
			null,
			'You have blocked this company. ',
			_react2.default.createElement(
				'a',
				{ href: '/relationships/blocked_clients' },
				'Manage Blocked Clients'
			)
		)
	);
});

var WMCompanyPageOverview = function WMCompanyPageOverview(props) {
	var name = props.name,
	    overview = props.overview,
	    website = props.website,
	    location = props.location,
	    yearFounded = props.yearFounded,
	    createdOn = props.createdOn,
	    employees = props.employees,
	    followedByUser = props.followedByUser,
	    followedByUserRequested = props.followedByUserRequested,
	    toggleFollowCompany = props.toggleFollowCompany,
	    blockedByUser = props.blockedByUser,
	    blockByUserRequested = props.blockByUserRequested,
	    blockFunc = props.blockFunc,
	    isPublic = props.isPublic;

	var overviewListItems = getOverviewListItems({
		website: website,
		location: location,
		yearFounded: yearFounded,
		createdOn: createdOn,
		employees: employees
	});
	var hasAvatar = props.avatar && props.avatar.length;

	return _react2.default.createElement(
		_WMPaper2.default,
		{
			rounded: false,
			style: _styles4.default.container,
			zDepth: 2
		},
		_react2.default.createElement(
			'div',
			{
				'data-attr-id': 'wm-company-page__title-columns',
				style: _styles4.default.columns
			},
			_react2.default.createElement(
				'div',
				{
					'data-attr-id': 'wm-company-page__title-left',
					style: _styles4.default.getColumnStyle(hasAvatar ? 'left' : 'none')
				},
				hasAvatar ? _react2.default.createElement(
					'div',
					{
						style: _styles4.default.avatarContainer,
						'data-attr-id': 'wm-company-page__avatar-container'
					},
					_react2.default.createElement('img', {
						src: props.avatar,
						alt: 'Logo',
						style: _styles4.default.avatar,
						'data-attr-id': 'wm-company-page__avatar'
					})
				) : getCompanyTitle(name, followedByUser, followedByUserRequested, toggleFollowCompany, blockFunc, blockedByUser, blockByUserRequested, isPublic)
			),
			_react2.default.createElement(
				'div',
				{
					'data-attr-id': 'wm-company-page__title-right',
					style: _styles4.default.getColumnStyle('right')
				},
				hasAvatar && getCompanyTitle(name, followedByUser, followedByUserRequested, toggleFollowCompany, blockFunc, blockedByUser, blockByUserRequested)
			)
		),
		_react2.default.createElement(
			'div',
			{
				'data-attr-id': 'wm-company-page__overview-columns',
				style: _styles4.default.columns
			},
			_react2.default.createElement(
				'div',
				{
					'data-attr-id': 'wm-company-page__overview-left',
					style: _styles4.default.getColumnStyle('left')
				},
				overviewListItems.map(function (listItem) {
					if (listItem.label) {
						return _react2.default.createElement(
							'div',
							{
								className: 'wm-company-page__overview-item',
								'data-attr-id': 'wm-company-page__overview-' + listItem.id + '-item',
								key: listItem.id,
								style: _styles4.default.overviewItem
							},
							_react2.default.createElement(
								_WMFontIcon2.default,
								{
									className: 'material-icons',
									id: 'wm-company-page__overview-item-' + listItem.id + '-icon',
									'data-attr-id': 'wm-company-page__overview-item-' + listItem.id + '-icon',
									color: _styles2.default.colors.baseColors.grey,
									style: _styles4.default.overviewItemIcon
								},
								listItem.icon
							),
							_react2.default.createElement(
								_WMText2.default,
								{
									inline: true,
									style: _styles4.default.overviewItemLabel
								},
								listItem.label
							)
						);
					}
					return null;
				})
			),
			_react2.default.createElement(
				'div',
				{
					'data-attr-id': 'wm-company-page__overview-right',
					style: _styles4.default.getColumnStyle('right')
				},
				_react2.default.createElement(
					_WMText2.default,
					{
						style: _styles4.default.overviewText
					},
					overview
				)
			)
		)
	);
};

var _default = WMCompanyPageOverview;
exports.default = _default;


WMCompanyPageOverview.propTypes = {
	name: _propTypes.PropTypes.string,
	website: _propTypes.PropTypes.string,
	location: _propTypes.PropTypes.shape({
		city: _propTypes.PropTypes.string,
		state: _propTypes.PropTypes.string,
		zip: _propTypes.PropTypes.string
	}),
	yearFounded: _propTypes.PropTypes.number,
	createdOn: _propTypes.PropTypes.string,
	employees: _propTypes.PropTypes.number,
	overview: _propTypes.PropTypes.string,
	avatar: _propTypes.PropTypes.string,
	followedByUser: _propTypes.PropTypes.bool.isRequired,
	followedByUserRequested: _propTypes.PropTypes.bool.isRequired,
	toggleFollowCompany: _propTypes.PropTypes.func.isRequired,
	blockFunc: _propTypes.PropTypes.func.isRequired,
	blockedByUser: _propTypes.PropTypes.bool.isRequired,
	blockByUserRequested: _propTypes.PropTypes.bool.isRequired,
	isPublic: _propTypes.PropTypes.bool
};

WMCompanyPageOverview.defaultProps = {
	name: '',
	website: '',
	location: _propTypes.PropTypes.shape({
		city: '',
		state: '',
		zip: ''
	}),
	yearFounded: 0,
	createdOn: '',
	employees: 0,
	overview: '',
	avatar: '',
	isPublic: false
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(getLocationString, 'getLocationString', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(getFoundedString, 'getFoundedString', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(getMemberSinceString, 'getMemberSinceString', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(getTeamMembersString, 'getTeamMembersString', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(getOverviewListItems, 'getOverviewListItems', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(getCompanyTitle, 'getCompanyTitle', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(WMCompanyPageOverview, 'WMCompanyPageOverview', 'src/components/WMCompanyPageOverview/template.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageOverview/template.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/components/WMCompanyPageOverview/template.js
// module id = yGNV
// module chunks = 62 63